import { render } from "./UserLoader.vue?vue&type=template&id=d0b7733c&ts=true"
import script from "./UserLoader.vue?vue&type=script&lang=ts"
export * from "./UserLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__